import { render, staticRenderFns } from "./accordion-flight-class.vue?vue&type=template&id=f72dbd14"
import script from "./accordion-flight-class.js?vue&type=script&lang=js&external"
export * from "./accordion-flight-class.js?vue&type=script&lang=js&external"
import style0 from "./accordion-flight-class.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports